module.exports = __webpack_public_path__ + "static/media/instagram.19c4c317.svg";